import { isCPFValid } from '@utils/data-complement/validate-inputs';
import { z } from 'zod';
import { toEmptyString } from './preprocess';

const extractDigits = (value: string) => value.replaceAll(/\D/g, '');

const hasElevenDigits = (value: string) => extractDigits(value).length === 11;

const isValid = (value: string) => isCPFValid(extractDigits(value));

/** CPF — sem preprocess (signUp, quiz). Preserva máscara. */
export const cpfField = z
  .string()
  .refine(hasElevenDigits, 'CPF inválido')
  .refine(isValid, 'CPF inválido');

/** CPF — com preprocess e validação inline (nationalUserSchema). Preserva máscara. */
export const cpf = z.preprocess(
  toEmptyString,
  z.string().refine(val => {
    const digits = extractDigits(val);
    if (digits.length !== 11) return false;
    if (/^(\d)\1+$/.test(digits)) return false;

    const calcDigit = (base: string, weight: number) => {
      const sum = base
        .split('')
        .reduce(
          (acc, digit, index) => acc + Number(digit) * (weight - index),
          0
        );
      const mod = sum % 11;
      return mod < 2 ? 0 : 11 - mod;
    };

    const d1 = calcDigit(digits.slice(0, 9), 10);
    const d2 = calcDigit(digits.slice(0, 10), 11);

    return Number(digits[9]) === d1 && Number(digits[10]) === d2;
  }, 'CPF inválido')
);
